// extracted by mini-css-extract-plugin
module.exports = {"root":"MultiRowSelect_root__-H4x9"};